import Vue from 'vue'
import Vuex from 'vuex'
import Vue2TouchEvents from 'vue2-touch-events'
import '@ungap/custom-elements';
import customElementPlugin from './plugins/customElement'
import directives from './directives'
import {registerCustomElements} from './customElements'
import {extend, ValidationObserver, ValidationProvider} from 'vee-validate'
import * as rules from 'vee-validate/dist/rules'
import de from 'vee-validate/dist/locale/de.json'
import Vuelidate from 'vuelidate'
import {format} from "@lib/formatter/currency";
// todo: enable sentry if available again: NSDJW-6343
//import * as Sentry from '@sentry/vue'
import store from '@store/index'

Vue.config.devtools = true
Vue.config.productionTip = false

if ((process.env.NODE_ENV || '') === 'production') {
  Vue.config.devtools = false
  Vue.config.debug = false;
  Vue.config.silent = true;
}

Vue.use(customElementPlugin)
Vue.use(Vuex)
Vue.use(Vue2TouchEvents)
Vue.use(Vuelidate)

Vue.filter('formatCurrency', format)

// validation
for (let rule in rules) {
    extend(rule, {
        ...rules[rule],
        message: de.messages[rule]
    })
}
Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)

Object.entries(directives).forEach(([name, func]) => Vue.directive(name, func))
// todo: enable sentry if available again: NSDJW-6343
/*Sentry.init({
    Vue,
    dsn: process.env.SENTRY_DSN,
    environment: process.env.NODE_ENV,
    integrations: [
      Sentry.browserTracingIntegration()
    ],
    tracesSampleRate: 0.25,
    tracePropagationTargets: [
      /journaway\.ddev\.site/,
      /^https:\/\/(?!(?:s4s\.journaway\.com|checkoutshopper(?:-test|-live)?\.adyen\.com)).*$/,
    ],
    trackComponents: ['Checkout', 'DateAndPrice']
});
Sentry.configureScope(scope => {
    scope.setExtra('checkout store', store.state.checkout)
    scope.setExtra('dateAndPrice store', store.state.dateAndPrice)
    scope.setExtra('funnel store', store.state.funnel)
})*/

registerCustomElements()
